import React from 'react';
import { Link } from 'react-router-dom'
import './card-style.css'


function EventCategoryCard(props) {
    let { id, category, count, level } = props.eventcategory;



    const targetPath = category === 'MathBowl' ? '/practice-subcategory' : '/' + props.target;

    return (
        <div className='card text-center shadow '>

            <div className='overflow'>
                {<Link to={{ pathname: targetPath, state: { category: category, level: level, premiumlevel: props.premiumlevel } }}>
                    <img src={props.imgsrc} alt='QuizWizard' className='card-img-top' width="200" height="250" />
                </Link>}
                <div className='card-body text-dark'>
                    <h4 className='card-text'>{props.title}</h4>
                    <h4 className='card-text'>{count === 0 ? 'No Events' : count === 1 ? '1 Event' : `${count} Events`}</h4>
                </div>
            </div>
        </div>

    );
}






export default EventCategoryCard;
